"use client";
import { useEffect } from "react";
import Marquee from "./marquee";
import { cn } from "@/lib/utils";
import { Badge } from "@/components/ui/badge";

export default function WallOfLove02() {
  const testimonialsRow1 = [
    {
      text: "Fazier crushes... had our best couple days ever and you've provided the most traffic to the site this month, and still driving sales to SvelteLaunch.",
      name: "Travis Mathis",
      position: "Founder of SvelteLaunch",
      img: "https://i.pravatar.cc/150?img=20",
    },
    {
      text: "I launched my 500K Agency offer in April. The community support was more than anything I could have expected.",
      name: "Paul Xue",
      position: "Founder of Spacestation Labs",
      img: "https://i.pravatar.cc/150?img=22",
    },
    {
      text: "Sweet! Fazier is awesome!",
      name: "Tyler Shukert",
      position: "DevRel engineer at Supabase",
      img: "https://i.pravatar.cc/150?img=19",
    },
    {
      text: "Hit the ground running on Fazier... A top-tier alternative to ProductHunt. 14.5% of my traffic came from there. Highly recommend it!",
      name: "Nathan Chua",
      position: "Founder of Snipowl",
      img: "https://i.pravatar.cc/150?img=11",
    },
    {
      text: "Definitely helped us make more sales!",
      name: "Tim White",
      position: "VP of Marketing, Founder of WildSEO",
      img: "https://i.pravatar.cc/150?img=23",
    },
    {
      text: "Fazier helped me to get a lot of traffic and feedback about my products. Thank you for the project!",
      name: "Serg Karakhanyan",
      position: "Founder of Larafast",
      img: "https://i.pravatar.cc/150?img=21",
    },
  ];

  const testimonialsRow2 = [
    {
      text: "Fazier crushes... had our best couple days ever and you've provided the most traffic to the site this month, and still driving sales to SvelteLaunch.",
      name: "Travis Mathis",
      position: "Founder of SvelteLaunch",
      img: "https://i.pravatar.cc/150?img=24",
    },
    {
      text: "I launched my 500K Agency offer in April. The community support was more than anything I could have expected.",
      name: "Paul Xue",
      position: "Founder of Spacestation Labs",
      img: "https://i.pravatar.cc/150?img=25",
    },
    {
      text: "Sweet! Fazier is awesome!",
      name: "Tyler Shukert",
      position: "DevRel engineer at Supabase",
      img: "https://i.pravatar.cc/150?img=26",
    },
    {
      text: "Hit the ground running on Fazier... A top-tier alternative to ProductHunt. 14.5% of my traffic came from there. Highly recommend it!",
      name: "Nathan Chua",
      position: "Founder of Snipowl",
      img: "https://i.pravatar.cc/150?img=27",
    },
    {
      text: "Definitely helped us make more sales!",
      name: "Tim White",
      position: "VP of Marketing, Founder of WildSEO",
      img: "https://i.pravatar.cc/150?img=28",
    },
    {
      text: "Fazier helped me to get a lot of traffic and feedback about my products. Thank you for the project!",
      name: "Serg Karakhanyan",
      position: "Founder of Larafast",
      img: "https://i.pravatar.cc/150?img=29",
    },
  ];

  useEffect(() => {
    const scrollAnimation = setInterval(() => {
      const scroller = document.querySelector(".scrolling-list");
      if (scroller) {
        scroller.scrollLeft += 1;
      }
    }, 30);

    return () => clearInterval(scrollAnimation);
  }, []);

  return (
    <section className="pb-20 pt-20 md:pb-32 md:pt-32 container mx-auto">
      <div className="text-center space-y-4 pb-16 mx-auto max-w-4xl">
        <Badge>WALL OF LOVE</Badge>
        <h2 className="mx-auto mt-4 text-3xl font-bold sm:text-5xl tracking-tight">
          Explore the Future of Innovation
        </h2>
        <p className="text-xl text-muted-foreground pt-1">
          In a realm where imagination meets technology, our platform fosters
          innovation, inspires creativity, and empowers every individual to
          transform their vision into reality.
        </p>
      </div>
      <div className="relative flex h-full w-full flex-col items-center justify-center overflow-hidden rounded-lg bg-background">
        <style>
          {`
          @keyframes marquee {
            from { transform: translateX(0); }
            to { transform: translateX(-100%); }
          }
          @keyframes marquee-vertical {
            from { transform: translateY(0); }
            to { transform: translateY(-100%); }
          }
          .animate-marquee {
            animation: marquee 20s linear infinite;
          }
          .animate-marquee-vertical {
            animation: marquee-vertical 20s linear infinite;
          }
        `}
        </style>
        <Marquee pauseOnHover className="[--duration:20s] ms-2">
          {testimonialsRow1.map((review, index) => (
            <ReviewCard key={index} {...review} />
          ))}
        </Marquee>
        <Marquee reverse pauseOnHover className="[--duration:20s]  mt-4">
          {testimonialsRow2.map((review, index) => (
            <ReviewCard key={index} {...review} />
          ))}
        </Marquee>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-1/3 bg-gradient-to-r from-background"></div>
        <div className="pointer-events-none absolute inset-y-0 right-0 w-1/3 bg-gradient-to-l from-background"></div>
      </div>
    </section>
  );
}

const ReviewCard = ({
  img,
  name,
  position,
  text,
}: {
  img: string;
  name: string;
  position: string;
  text: string;
}) => {
  return (
    <figure
      className={cn(
        "relative w-72 cursor-pointer overflow-hidden rounded-xl border p-4 border-gray-950/[.1] bg-gray-950/[.01] hover:bg-gray-950/[.05] dark:border-gray-50/[.1] dark:bg-gray-50/[.10] dark:hover:bg-gray-50/[.15]"
      )}
    >
      <div className="flex flex-row items-center gap-2">
        <img className="rounded-full" width="32" height="32" alt="" src={img} />
        <div className="flex flex-col">
          <figcaption className="text-sm font-medium dark:text-white">
            {name}
          </figcaption>
          <p className="text-xs font-medium dark:text-white/40">{position}</p>
        </div>
      </div>
      <blockquote className="mt-2 text-sm">{text}</blockquote>
    </figure>
  );
};
